// src/pages/Turniere/TurnierRegistrationPage.jsx
//
// Ein Anmeldeweg für Vereine (V17, 18.10.2026). Bis heute gab es zwei Seiten,
// auf denen ein Verein seine Sportler anmeldete: /registration (diese Seite,
// eigene Turnierliste um dasselbe Anmeldefenster) und den Vereinsbereich
// /verein. Nur im Vereinsbereich gab es die Sammelanmeldung (CSV-Datei,
// „wie beim letzten Turnier“, „auch für …“), Vormerken und die Übersicht der
// eigenen Anmeldungen. Diese Adresse leitet jetzt dorthin weiter:
//   Verein  → /verein?turnier=<id>   (öffnet die Anmeldung zum Turnier)
//   Admin   → /dashboard/vereine     (Verein wählen, dort „Anmelden“)
//   niemand → /anmelden
import React from 'react';
import { Navigate, useSearchParams } from 'react-router-dom';

const rolle = () => {
  for (const schluessel of ['clubData', 'adminData']) {
    try {
      const d = JSON.parse(localStorage.getItem(schluessel) || 'null');
      if (d?.user) return d.user.role === 'admin' ? 'admin' : 'verein';
    } catch { /* ungültiger Eintrag: weiter */ }
  }
  return null;
};

export default function TurnierRegistrationPage() {
  const [suchParameter] = useSearchParams();
  const turnierId = suchParameter.get('turnierId') || suchParameter.get('turnier');
  const r = rolle();
  if (r === 'admin') return <Navigate to="/dashboard/vereine" replace />;
  if (r === 'verein') return <Navigate to={turnierId ? `/verein?turnier=${encodeURIComponent(turnierId)}` : '/verein'} replace />;
  return <Navigate to="/anmelden" replace />;
}
